<ng-container *ngIf="!!orderTypeConfigs">
  <select *ngIf="!radioStyle"
          [ngModel]="selectedOrderTypeConfig" (ngModelChange)="onOrderTypeConfigChange($event)"
          class="form-control primary-bg-color primary-text-color"
          [attr.aria-label]="'component.header.store_info.store_selection.order_type_selector.order_type' | translate">
    <option *ngFor="let orderTypeConfig of orderTypeConfigs" [ngValue]="orderTypeConfig"
            [hidden]="orderAheadConfig?.type === orderTypeConfig.type">
      {{orderTypeConfig.displayName || orderTypeConfig.type}}
    </option>
  </select>

  <div *ngIf="radioStyle" class="radio-selector">
    <ng-container *ngFor="let orderTypeConfig of orderTypeConfigs">
      <fts-themeable-radio
        *ngIf="orderAheadConfig?.type !== orderTypeConfig.type"
        class="primary-text-color margin-5"
        [name]="'store-selection-order-type'"
        [label]='orderTypeConfig.displayNameOrName'
        [value]="orderTypeConfig.type"
        [ngModel]="selectedRadioValue"
        [noPadding]="true"
        [disabled]="disabled"
        [ariaLabel]="orderTypeConfig.displayNameOrName"
        (ngModelChange)="onRadioChange($event)">
      </fts-themeable-radio>
    </ng-container>

    <fts-themeable-radio
      *ngIf="orderAheadConfig"
      class="primary-text-color margin-5"
      [name]="'store-selection-order-type'"
      [label]="'component.order_type_chooser.order_ahead' | translate"
      [value]="ORDER_AHEAD_VALUE"
      [ngModel]="selectedRadioValue"
      [noPadding]="true"
      [disabled]="disabled"
      [ariaLabel]="'component.order_type_chooser.order_ahead' | translate"
      (ngModelChange)="onRadioChange($event)">
    </fts-themeable-radio>
  </div>
</ng-container>
